import axios from "./HttpRequestCustomerApp";


function getListSuggest(text) {
   return axios.get('/web/product/suggest/' + text);
}
export { getListSuggest}